// extracted by mini-css-extract-plugin
export default {"menuLink":"Menu_menuLink__1B9Ld","menuTitle":"Menu_menuTitle__C58dC","menuButton":"Menu_menuButton__gYRFk"};